// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"wM-z","loadingMedia":"xM-z","reviewsImagesAndVideos":"yM-z","limitHeight":"zM-z"};